module.exports = __webpack_public_path__ + "static/img/flyingTreasure.155191f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posters/flyingTreasure.jpg
// module id = 46
// module chunks = 0